/**
 * Hero 3D model: rotate when in view, click to control, idle reset to front.
 */
(function () {
  const wrappers = document.querySelectorAll('[data-hero-model-viewer]');
  if (!wrappers.length) return;
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const MOBILE_INTERACTION_TIMEOUT_MS = 4500;

  function init(wrap) {
    const viewer = wrap.querySelector('model-viewer');
    if (!viewer) return;

  const defaultOrbit = wrap.dataset.defaultOrbit || '-87.3deg 82.06deg 10.96m';
  const orbitSpeed = wrap.dataset.orbitSpeed || '12deg';
  const rotateInView = wrap.dataset.rotateInView !== 'false';
  const idleReset = wrap.dataset.idleReset !== 'false';
  const idleResetSec = Math.max(1, parseInt(wrap.dataset.idleResetSec, 10) || 3);

  let inView = false;
  let userControlled = false;
  let idleTimer = null;
  let interactionTimer = null;
  let mobileInteractionEnabled = false;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let pointerDownAt = 0;

  function isMobileView() {
    return mobileQuery.matches;
  }

  function clearInteractionTimer() {
    if (!interactionTimer) return;
    clearTimeout(interactionTimer);
    interactionTimer = null;
  }

  function setMobileInteractionState(isEnabled) {
    if (!isMobileView()) return;
    mobileInteractionEnabled = isEnabled;
    wrap.dataset.mobileInteraction = isEnabled ? 'active' : 'idle';

    if (isEnabled) {
      viewer.setAttribute('camera-controls', '');
      userControlled = true;
      stopOrbit();
      return;
    }

    viewer.removeAttribute('camera-controls');
    userControlled = false;
    if (inView && rotateInView) startOrbit();
  }

  function scheduleMobileInteractionReset() {
    if (!isMobileView()) return;
    clearInteractionTimer();
    interactionTimer = setTimeout(function () {
      setMobileInteractionState(false);
    }, MOBILE_INTERACTION_TIMEOUT_MS);
  }

  function enableMobileRotateModeFromUser() {
    if (!isMobileView()) return;
    if (idleTimer) {
      clearTimeout(idleTimer);
      idleTimer = null;
    }
    setMobileInteractionState(true);
    scheduleMobileInteractionReset();
  }

  function startOrbit() {
    if (!rotateInView || !inView || userControlled) return;
    viewer.setAttribute('auto-rotate', '');
    viewer.setAttribute('rotation-per-second', orbitSpeed);
  }

  function stopOrbit() {
    viewer.removeAttribute('auto-rotate');
  }

  function resetToFront() {
    viewer.setAttribute('camera-orbit', defaultOrbit);
    userControlled = false;
    if (inView && rotateInView) startOrbit();
  }

  function scheduleIdleReset() {
    if (!idleReset) return;
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      idleTimer = null;
      resetToFront();
    }, idleResetSec * 1000);
  }

  function onPointerDown(event) {
    pointerDownAt = Date.now();
    pointerStartX = 0;
    pointerStartY = 0;
    userControlled = true;
    stopOrbit();
    if (idleTimer) {
      clearTimeout(idleTimer);
      idleTimer = null;
    }

    if (!isMobileView()) return;

    clearInteractionTimer();
    if (event instanceof PointerEvent) {
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    }
  }

  function onPointerUp(event) {
    if (isMobileView()) {
      const hasPointer = event instanceof PointerEvent;
      const moveX = hasPointer ? Math.abs(event.clientX - pointerStartX) : 0;
      const moveY = hasPointer ? Math.abs(event.clientY - pointerStartY) : 0;
      const totalMove = Math.sqrt(moveX * moveX + moveY * moveY);
      const elapsed = Date.now() - pointerDownAt;
      const isTap = totalMove < 10 && elapsed < 500;

      if (!mobileInteractionEnabled) {
        if (isTap) {
          enableMobileRotateModeFromUser();
        } else {
          userControlled = false;
          if (inView && rotateInView) startOrbit();
        }
        return;
      }

      scheduleMobileInteractionReset();
    }

    scheduleIdleReset();
  }

  function handleViewportChange() {
    clearInteractionTimer();
    if (isMobileView()) {
      setMobileInteractionState(false);
      return;
    }

    mobileInteractionEnabled = false;
    delete wrap.dataset.mobileInteraction;
    viewer.setAttribute('camera-controls', '');
    if (inView && rotateInView) startOrbit();
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting;
        if (inView && !userControlled && rotateInView) startOrbit();
        else stopOrbit();
      });
    },
    { threshold: 0.2, rootMargin: '0px' }
  );

  observer.observe(wrap);

  viewer.addEventListener('pointerdown', onPointerDown);
  viewer.addEventListener('pointerup', onPointerUp);
  viewer.addEventListener('pointerleave', onPointerUp);

  const tapHint = wrap.querySelector('[data-hero-model-tap-hint]');
  if (tapHint) {
    tapHint.addEventListener('click', function onTapHintClick() {
      if (!isMobileView()) return;
      enableMobileRotateModeFromUser();
    });
  }

  mobileQuery.addEventListener('change', handleViewportChange);
  handleViewportChange();
  }

  function run() {
    wrappers.forEach(init);
  }

  if (customElements.get('model-viewer')) {
    run();
  } else {
    customElements.whenDefined('model-viewer').then(run);
  }
})();
